// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/angular2-toaster/toaster.css
// module id = ./node_modules/angular2-toaster/toaster.css
// module chunks = 4